// Backend can lag before /me reflects the newly-set first/last name. The
// completeAccount mutation waits for this delay before resolving so consumers
// (e.g. the submit button) see the loading state across the full window.
// Tests mock this module to bypass the wait.
export const COMPLETE_ACCOUNT_PROPAGATION_DELAY_MS = 2000;

export const waitForCompleteAccountPropagation = () =>
  new Promise<void>((resolve) => setTimeout(resolve, COMPLETE_ACCOUNT_PROPAGATION_DELAY_MS));
